const STOREFRONT_API_URL = `https://${Shopify.shop}/api/2024-07/graphql.json`;
const STOREFRONT_API_ACCESS_TOKEN = 'b6f12f7cc70b9b2bbe6f0c13f141fc2d'; // from Molsoft Tools app "Storefront API access token"

/**
 * Fetches inventory quantities for variants using the Storefront API.
 * Requires Storefront API access scopes:
 *  1. unauthenticated_read_product_listings
 *  2. unauthenticated_read_product_inventory
 *
 * @param {String[]} variantIds - Array of Shopify Variant IDs (e.g., ['123456789'])
 * @returns {Object} Map of variantId => quantityAvailable
 */
export async function fetchShopifyVariantInventory(variantIds) {
  if (!variantIds.length) {
    console.error("No variant IDs provided to fetchShopifyVariantInventory");
    return {};
  }

  // Limit to max 100 IDs due to Shopify API nodes query limit
  const limitedIds = variantIds.slice(0, 100);
  const globalVariantIds = limitedIds.map(id => {
    const trimmed = String(id).trim();
    return trimmed.startsWith("gid://") ? trimmed : `gid://shopify/ProductVariant/${trimmed}`;
  });

  const query = `
    query getVariantInventory($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          quantityAvailable
        }
      }
    }
  `;

  try {
    const response = await fetch(STOREFRONT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_API_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: { ids: globalVariantIds }
      }),
    });

    const { data, errors } = await response.json();

    if (errors) {
      console.error("Shopify API errors:", errors);
      return {};
    }

    const inventoryMap = {};

    data.nodes.forEach(variantNode => {
      if (!variantNode?.id) return;

      const idMatch = variantNode.id.match(/ProductVariant\/(\d+)/);
      if (!idMatch) return;

      const variantId = idMatch[1];
      inventoryMap[variantId] = variantNode.quantityAvailable;
    });

    return inventoryMap;
  } catch (error) {
    console.error("Error fetching variant inventory from Shopify:", error);
    return {};
  }
}

